import PropTypes from 'prop-types';
import React from 'react';
import { ThumbsDown, ThumbsUp } from 'react-feather';
import RatingOptionButton from '../../common/rating-option-button';
import { ThumbScores } from '../../constants/feedback-constants';

const renderThumbsUpIcon = () => <ThumbsUp size={28} />;
const renderThumbsDownIcon = () => <ThumbsDown size={28} />;

const ThumbsRating = ({ value, onChange }) => (
  <div className="flex gap-4">
    <RatingOptionButton
      score={ThumbScores.UP}
      renderIcon={renderThumbsUpIcon}
      highlighted={value === ThumbScores.UP}
      className="feedback-icon-option"
      onSelect={onChange}
    />
    <RatingOptionButton
      score={ThumbScores.DOWN}
      renderIcon={renderThumbsDownIcon}
      highlighted={value === ThumbScores.DOWN}
      className="feedback-icon-option"
      onSelect={onChange}
    />
  </div>
);

ThumbsRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

ThumbsRating.defaultProps = {
  value: null,
};

export default ThumbsRating;
